import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import {
    hideSrpInventoryPage,
    isArrayNotEmpty, isCompletedHotelInfoHistory,
    searchFirstObjectInList, searchObjectListBoolean
} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import * as BrandConst from '../../../../constants/BrandConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import RateplansService from '../../../../services/RateplansService'
import RoomTypesService from '../../../../services/RoomTypesService'
import { getMinRoomsRequiredForBox, isRoomTypeAccessible } from '../../../../utilities/FormHelper'
import {getSessionItem, setSessionItem} from '../../../../utilities/SessionHelper'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import Card from '../../../molecules/Card/Card'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './BoxInventory.scss'

class BoxInventory extends Component {

    constructor(props) {
        super(props)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const hideSrpInventory = hideSrpInventoryPage(hotelInfoCompletedHistory, this.props.checklist, hotelInfo.brandCode)
        const isRadissonBrand = BrandConst.RADISSON_BRAND_CODES.includes(hotelInfo.brandCode)
        const isCambria = hotelInfo.brandCode === BrandConst.BRAND_CODE_CAMBRIA;
        setSessionItem("isCambria")

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            isCambria: isCambria,
            isRadissonBrand: isRadissonBrand,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            hideSrpInventory: hideSrpInventory,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    initialValues = {
        boxInventory: []
    }

    validationSchema = Yup.object().shape({
        boxInventory: Yup.array().of(
            Yup.object().shape({
                boxName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                isParticipation: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                dailyRoomCount: Yup.number().when('boxName', {
                    is: (boxName) => boxName === FormConst.BOX_NAME_EMPLOY ,
                    then: Yup.number().when('boxName', (boxName) => Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED)
                        .typeError("Please enter numbers")
                        .positive()
                        .min(getMinRoomsRequiredForBox(boxName, this.state.isCambria), "Minimum "+getMinRoomsRequiredForBox(boxName, this.state.isCambria)+" required")),
                    otherwise: Yup.number().notRequired(),
                }),
                roomTypes: Yup.array().when('isParticipation', {
                    is: (isParticipation) => isParticipation,
                    then: Yup.array().of(
                        Yup.object().shape({
                            code: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                            isChecked: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED)
                        })
                    ).test('Room types selected', 'At least one room type should be selected', roomTypes => {
                        return roomTypes.some(roomType => roomType.isChecked)
                    })
                })
            })
        )
    })

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let roomTypes = this.state.hotelInfoCompletedHistory.newEntity?.hotelRoomTypes?.roomTypes;

            if (isArrayNotEmpty(roomTypes)) {
                await this.buildBoxInventories(roomTypes)
            } else {
                this.setState({error: 'Could not retrieve details', isLoading: false})
            }
        } else {
            await RoomTypesService.getRoomTypes({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    if (isArrayNotEmpty(response.roomTypes)) {
                        await this.buildBoxInventories(response.roomTypes)
                    } else {
                        this.setState({
                            roomTypes: response.roomTypes,
                            isLoading: false
                        })
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while retrieving Room Types data'
                    })
                })
        }
    }

    async buildBoxInventories (roomTypes){
        await RateplansService.getBoxInventory({ hotelCode: this.state.hotelCode })
            .then(boxInventoryResponse => {
                let boxInventories = boxInventoryResponse.boxInventories;
                this.buildInitialValues(roomTypes, boxInventories);
            }).catch(error => {
                this.setState({
                                  isLoading: false,
                                  showErrorModal: true,
                                  errorMessage: 'There was an error while retrieving Box Inventory data'
                              })
            })
    }

    buildInitialValues = (roomTypes, boxInventory) => {
        let initialValues = {
            boxInventory: boxInventory.filter(box => box.display)
        }

        initialValues.boxInventory.forEach(box => {
            let roomTypesOptions = roomTypes.map(roomType => {
                return {
                    code: roomType.hotelRoomTypeCode,
                    isChecked: searchObjectListBoolean('code', roomType.hotelRoomTypeCode, box.roomTypes),
                    isAccessible: isRoomTypeAccessible(roomType)
                }
            })

            box.isParticipation = box.participationMandatory || (Array.isArray(box.roomTypes) && box.roomTypes.length > 0)
            box.roomTypes = roomTypesOptions

            if(box.dailyRoomCount === undefined || box.dailyRoomCount === '') {
                box.dailyRoomCount = ''
            }

        })

        this.setState({
            roomTypes: roomTypes,
            boxInventory: boxInventory,
            initialValues: initialValues,
            isLoading: false
        })
    }

    handleSubmit = (data) => {
        let putData = {
            hotelCode: this.state.hotelCode,
            boxInventories: []
        }

        data.boxInventory.forEach(box => {
            if (box.isParticipation) {

                const roomTypes = []
                box.roomTypes.forEach(roomType => {
                    if (roomType.isChecked) {
                        roomTypes.push({
                            code: roomType.code
                        })
                    }
                })
                putData.boxInventories.push({
                    boxName: box.boxName,
                    description: box.description,
                    display: box.display,
                    participationMandatory: box.participationMandatory,
                    dailyRoomCount: box.dailyRoomCount,
                    roomTypes: roomTypes
                })
            }
        })

        this.props.onPut(putData)
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                this.props.history.push(RouteConst.ROUTE_RATEPLANS_PAGE)
            }
        }
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    render() {
        return (
            <div className='box-inventory-page'>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, isSubmitting, resetForm, handleChange }) => (
                            <Form>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_RATEPLANS_PAGE}>Rateplans</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Box Inventory</li>
                                    </ol>
                                </nav>

                                <p className='helper-text'>{FormConst.BOX_INVENTORY_PAGE_HELPER_TEXT}</p>
                                <div id='box-inventory-form-fields' className='box-inventory-form-fields'>
                                    {
                                        values.boxInventory.map((box, index) => {
                                            if(!this.state.isRadissonBrand && box.boxName == BrandConst.BOX_RHGA) {
                                                return
                                            }
                                            return <Card
                                                header={box.boxName === FormConst.BOX_NAME_NET ? FormConst.BOX_DESCRIPTION_NET : box.description}
                                                id={box.boxName + '-card'}
                                                key={index}
                                                text={
                                                    (
                                                        <>
                                                            {
                                                                box.participationMandatory === false
                                                                && <ToggleSwitch
                                                                    id={box.boxName + '-participation'}
                                                                    name={`boxInventory.${index}.isParticipation`}
                                                                    checked={box.isParticipation}
                                                                    label='Do you intend to participate in this program?'
                                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                    onChange={handleChange} />
                                                            }
                                                            {
                                                                box.isParticipation === true
                                                                && <>
                                                                    <p>
                                                                        {
                                                                            `Inventory for the 
                                                                                            ${box.boxName === FormConst.BOX_NAME_NET
                                                                                ? FormConst.BOX_DESCRIPTION_NET : box.description} 
                                                                                            is controlled by the ${box.boxName} box.`
                                                                        }
                                                                    </p>
                                                                    <TextInput
                                                                        name={`boxInventory.${index}.dailyRoomCount`}
                                                                        type='number'
                                                                        min={0}
                                                                        label={`How many rooms should we load in the ${box.boxName} box?`}
                                                                    />

                                                                    <div className='room-types-fields'>
                                                                        {
                                                                            box.boxName === FormConst.BOX_NAME_NET || box.boxName === FormConst.BOX_NAME_EXTNT
                                                                                ? <p className='helper-text'>{FormConst.BOX_INVENTORY_PAGE_ROOM_TYPE_BOX_ADA_HELPER_TEXT}</p>
                                                                                : <p className='helper-text'>{FormConst.BOX_INVENTORY_PAGE_ROOM_TYPE_HELPER_TEXT}</p>
                                                                        }
                                                                        {
                                                                            box.roomTypes.map((roomType, roomTypeIndex) =>
                                                                                <>
                                                                                    <TextInput
                                                                                        type='checkbox'
                                                                                        id={roomType.code + '-' + roomTypeIndex}
                                                                                        name={`boxInventory.${index}.roomTypes.${roomTypeIndex}.isChecked`}
                                                                                        checked={roomType.isChecked}
                                                                                        suffix={
                                                                                            roomType.isAccessible
                                                                                                ? <>
                                                                                                    {roomType.code}
                                                                                                    {
                                                                                                        (box.boxName === FormConst.BOX_NAME_NET || box.boxName === FormConst.BOX_NAME_EXTNT)
                                                                                                        && <span className='text-orange'>*</span>
                                                                                                    }
                                                                                                </>
                                                                                                : roomType.code
                                                                                        }
                                                                                        onChange={handleChange}
                                                                                        key={`${index}-${roomTypeIndex}`} />
                                                                                </>
                                                                            )
                                                                        }
                                                                        <p className='error'>
                                                                            {
                                                                                errors
                                                                                && errors.boxInventory
                                                                                && isArrayNotEmpty(errors.boxInventory)
                                                                                && errors.boxInventory[index]?.roomTypes
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </>
                                                            }
                                                        </>
                                                    )
                                                }
                                                footer={box.participationMandatory ? 'Participation is mandatory' : ''
                                                } />
                                        }
                                        )
                                    }

                                </div>
                                <FormFooter
                                    form={{
                                        previous: { title: SideNavEntryMapping.RATE_PLANS.current.title, route: SideNavEntryMapping.RATE_PLANS.current.route },
                                        next: this.state.hideSrpInventory ? { title: 'Third Party Rate Programs', route: RouteConst.ROUTE_OTA_RATE_PROGRAMS_PAGE } : { title: 'SRP Inventory', route: RouteConst.ROUTE_SRP_INVENTORY_PAGE }
                                    }}
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    resetName={FormConst.RESET_BUTTON_TEXT}
                                    onReset={this.handleClearForm}
                                    submitDisabled={isSubmitting} />
                                <FormModal
                                    id='hotel-info-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='hotel-info-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='hotel-info-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        boxInventoryResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_BOX_INVENTORY_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_BOX_INVENTORY_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(BoxInventory, SideNavEntryMapping.RATE_PLANS))
